export default __webpack_public_path__ + "static/media/ponderosa_oak.504ca246.png";